import useResponsive from '@/hooks/useResponsive';
import { Stack, useTheme } from '@mui/material';
import Image from 'next/image';

const ShitcoinFooter = () => {
  const { matches } = useResponsive();
  return (
    <Stack
      alignItems="center"
      gap={{ xs: 1.5, lg: 2 }}
      mb={{ xs: 21.5, lg: 24.5 }}
    >
      <Image
        src="/assets/shitcoin/logo_rabex.svg"
        width={37}
        height={48}
        alt=""
        style={{ marginBottom: matches({ xs: '4px', lg: '10px' }) }}
      />
      <Image
        src="/assets/shitcoin/typography_rabex.svg"
        width={matches({ xs: 77, lg: 110 })}
        height={matches({ xs: 18, lg: 26 })}
        alt=""
      />
      <Image
        src="/assets/shitcoin/tagline_rabex.svg"
        width={matches({ xs: 77, lg: 109 })}
        height={matches({ xs: 6, lg: 9 })}
        alt=""
      />
    </Stack>
  );
};

export default ShitcoinFooter;
